import { mapDTO } from '@twistezo/ts-dto-mapper'
import { omit } from 'lodash'

import { Schema } from 'features/inventory/domain/forms/RichPlacementsForm/sections/MultiAnchorForm/schema'
import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { Variables } from './types'

type From = Schema
type To = Omit<Variables, 'domainId'>

export const toDTO = (from: From, ability: Ability): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      adUnitIds,
      customizeAppearance,
      customizeBasicSettings,
      customStyling,
      displayAfterUserInteraction,
      enabled,
      fullWidthMode,
      showCloseButton,
      singleAdViewTime,
    }: From): To => {
      const constantFields: Omit<To, 'adUnitIds'> = {
        customizeApperanceEnabled: customizeAppearance,
        customizeBasicSettingsEnabled: customizeBasicSettings,
        customStyling: JSON.parse(customStyling),
        displayAfterUserInteractionEnabled: displayAfterUserInteraction,
        enabled,
        fullWidthModeEnabled: fullWidthMode,
        showCloseButtonEnabled: showCloseButton,
        singleAdViewTime,
      }

      const variableFields: Pick<To, 'adUnitIds'> = {
        adUnitIds: adUnitIds.right,
      }

      return {
        ...constantFields,
        ...omit(
          variableFields,
          fieldsToOmit<Variables>({
            adUnitIds: ability.cannot(
              'update',
              'DomainRichPlacementsFeature-multiAnchorAdUnitConnection',
            ),
          }),
        ),
      }
    },
  )
